<script lang="ts">
	import {
		DashControlWidget,
		type DashDeviceWidgetPropsTypes,
	} from '@Shelly/shelly-design-system/index';
	import ControlsScene from 'src/components/Lists/Scenes/ControlsScene.svelte';
	import { hasMissingSceneData } from 'src/components/Scenes/helpers/has_missing_scene_data';
	import { load_image_from } from 'src/helpers/interface_helpers';
	import { devices } from 'src/stores/lists/devices';
	import { edit } from 'src/stores/ui/edit_lists';
	import { scenes } from 'src/stores/lists/scenes';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { format } from 'svelte-i18n';

	export let sceneWidget;

	let missingDataLabels = [];
	let additionalText: DashDeviceWidgetPropsTypes['additionalText'] = {
		value: '',
	};

	function updateMissingSceneData(scene) {
		//This function will update the missingDataLabels object with the missing data for each scene. It will be called on every update of the scenes list.
		const labelListWithMissingData = {
			hasMissingDevice: {
				icon: 'fa-light fa-triangle-exclamation',
				id: 0,
				value: $format('label_missing_device', { default: 'Missing Device' }),
				type: 'hasMissingDevice',
			},
			hasMissingWeatherCondition: {
				icon: 'fa-light fa-triangle-exclamation',
				id: 1,
				value: $format('label_invalid_weather_condition', {
					default: 'Invalid weather condition',
				}),
				type: 'hasMissingWeatherCondition',
			},
		};
		const isMissingData = hasMissingSceneData(scene)?.missingData;

		if (isMissingData) {
			isMissingData.forEach((missingData) => {
				if (!missingDataLabels?.includes(labelListWithMissingData[missingData])) {
					{
						missingDataLabels = [
							...missingDataLabels,
							labelListWithMissingData[missingData],
						];
					}
				}
			});
		} else {
			missingDataLabels = [];
		}
	}

	$: scene = $scenes[sceneWidget.id];

	$: value = !scene ? sceneWidget?.id : scene?._meta.name;

	$: avatar = !scene
		? { icon: 'fat fa-triangle-exclamation text-color-warning' }
		: {
				backgroundColor: scene?._meta?.backgroundColor,
				image: scene?._meta?.image ? load_image_from(scene?._meta.image) : '',
			};

	$: {
		if ($scenes || $devices) {
			updateMissingSceneData(scene); //update the missingDataLabels with the missing data on every update of the scenes list or devices list
		}
	}

	$: hasMissingData = missingDataLabels?.length > 0;

	//Temporary solution, for now we can show only 1 error msg
	$: missingDataPriority =
		missingDataLabels?.length > 1
			? missingDataLabels?.find((item) => item.type === 'hasMissingDevice')
			: missingDataLabels?.[0];

	$: additionalText = !scene
		? {
				value: $format('label_missing_scene', {
					default: 'Missing Scene',
				}),
				type: 'warning',
			}
		: {
				value: hasMissingData ? missingDataPriority.value : '',
				icon: hasMissingData ? missingDataPriority.icon : '',
				type: hasMissingData ? 'warning' : undefined,
			};
</script>

<DashControlWidget
	aria-label="Dash Control Widget"
	class="cursor-pointer"
	{value}
	{avatar}
	{additionalText}
	selected={sceneWidget.id === $sidePanelStateCombined?.id}
	hideSlotRight={!scene || $edit}
	on:click
>
	<ControlsScene slot="right" variant="dashControlWidget" item={scene} showEnableBtn={false} />
</DashControlWidget>
